import { useGetInspectorRolesForClaim } from '@/components/Domains/Claims'
import { useQuery } from '@eigtech/ui-shared-api'
import {
  GetInspectionsRequest,
  getAllClaimsInspectionsQueryOptions,
  getClaimInspectionsQueryOptions,
} from '@eigtech/ui-shared-claims-lib'
import { useGetDelegateUserActiveContacts } from '../user'

export function useGetAllClaimsInspections(request?: GetInspectionsRequest) {
  const { contactIds } = useGetDelegateUserActiveContacts()

  return useQuery(
    getAllClaimsInspectionsQueryOptions({
      ...request,
      filter: [
        ...(request?.filter ?? []),
        {
          field: 'inspectorId',
          operator: 'ANYOF',
          value: contactIds,
        },
      ],
    })
  )
}

export function useGetClaimInspections(claimNumber: string, request?: GetInspectionsRequest) {
  // TODO: Need to assert contactIds when filtering
  // const { contactIds } = useGetDelegateUserActiveContacts()

  const inspectorRoles = useGetInspectorRolesForClaim(claimNumber)

  return useQuery(
    getClaimInspectionsQueryOptions(
      claimNumber,
      {
        ...request,
        filter: [
          ...(request?.filter ?? []),
          // TODO: Need to assert contactIds when filtering
          // {
          //   field: 'fieldAdjusterId',
          //   operator: 'ANYOF',
          //   value: contactIds,
          // },
          {
            field: 'inspectorRole',
            operator: 'ANYOF',
            value: inspectorRoles,
          },
        ],
      },
      { enabled: !!inspectorRoles.length }
    )
  )
}
